import clsx from 'clsx';

type AdminStatusBadgeProps = {
  status: string;
  statusMap: Record<string, { label: string; className: string }>;
  fallbackClassName?: string;
};

/** ステータスに応じた色付きバッジを表示する */
export default function AdminStatusBadge({
  status,
  statusMap,
  fallbackClassName = 'bg-[#e8e8e8] text-[#555]',
}: AdminStatusBadgeProps) {
  const info = statusMap[status] ?? { label: status, className: fallbackClassName };
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center rounded-full px-3 py-1 text-xs font-bold',
        info.className
      )}
    >
      {info.label}
    </span>
  );
}
